// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear-button[data-v-21f8d20c] {\n  cursor: pointer;\n  padding: 4px;\n  margin: 0 8px;\n}\n.clear-button svg[data-v-21f8d20c] {\n  width: 16px;\n  height: 16px;\n  color: #4e5a6b;\n}\n.briq-date-time-picker[data-v-21f8d20c] {\n  width: 100%;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
